import React from "react";
import { UsersCards } from "../..";
import { teamData } from "../../../assets/data/teamData";

export default function TeamSection() {
	const { boards, volunteers } = teamData;

	return (
		<section className="">
			<div className="mb-5">
				<h5 className="blueCool mb-4 text-center">
					Board of Directors
				</h5>

				<UsersCards data={boards} />
			</div>

			<div>
				<h5 className="blueCool mb-4 text-center">Volunteers</h5>

				<UsersCards data={volunteers} />
			</div>
		</section>
	);
}
